export const BatteryStatus = {
  Active: "Active",
  Inactive: "Inactive",
  Locked: "Locked",
};
